import React from 'react';

/**
 * When set, signals to FormBox (rendered inside V2 form components via
 * FormsFactory) that it should behave as a per-section editor inside the
 * candidate profile instead of its default linear "Back / Save & Proceed"
 * flow:
 *   - render Cancel / Save-section buttons only
 *   - skip register / navigate / assessment-submit side effects
 *   - mark `formKey` as completed after a successful save
 *   - POST completed_assessment when every completed-forms field is true and
 *     the candidate's completed_assessment is still unset
 *   - call `onSaved` so the parent can refresh data + completion chips
 *
 * Context is read in `src/components/common/FormBox/FormBox.tsx`. When the
 * context is null (default) FormBox keeps its original behaviour, so other
 * call sites (sales onboarding, client flow) are unaffected.
 */
export interface ProfileEditContextValue {
    active: true;
    formKey: string;
    saveLabel?: string;
    cancelLabel?: string;
    /** Candidate's completed_assessment timestamp; null/empty means unset. */
    completedAssessment?: string | Date | null;
    /** Profile sections that must be true before stamping completed_assessment. */
    requiredFormKeys?: readonly string[];
    /** Data-only spouse profiles can be saved before an account email is provided. */
    isEmailOptional?: boolean;
    onSaved?: () => void;
    onCancel?: () => void;
}

export const ProfileEditContext = React.createContext<ProfileEditContextValue | null>(null);
